import { useTranslation } from '@ecomm/i18n'
import { useFormStyles } from '@ecomm/promotions-hooks'

export function LeadCaptureSuccess() {
  const { textStyles } = useFormStyles()
  const { t } = useTranslation('common')

  return (
    <div
      className="border-0 border-t lg:border-t-0 border-solid border-t-neutral-light-100 h-full w-full pt-2 lg:pt-0 flex flex-col md:flex-row lg:flex-col gap-1 text-center items-center justify-center"
      data-component="LeadCaptureFormSuccess"
    >
      <p
        className={`max-lg:text-neutral-black m-0 font-bold md:text-lg ${textStyles}`}
      >
        {t('lead-capture-form.success-message.title')}
      </p>
      <p
        className={`max-lg:text-neutral-black m-0 text-xs md:text-sm font-bold ${textStyles}`}
      >
        {t('lead-capture-form.success-message.description')}
      </p>
    </div>
  )
}
